module.exports = __webpack_public_path__ + "static/media/task-complete.dc48bc73.svg";